import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { TdSearchInputComponent } from '../search-input/search-input.component';
export class TdSearchBoxComponent {
private _searchVisible: boolean = false;
   _searchInput: TdSearchInputComponent;
/**
 * @param {?} value
 * @return {?}
 */
set value(value: any) {
    this._searchInput.value = value;
  }
/**
 * @return {?}
 */
get value(): any {
    return this._searchInput.value;
  }
/**
 * @return {?}
 */
get searchVisible(): boolean {
    return this._searchVisible;
  }
/**
 * backIcon?: string
 * The icon used to close the search toggle, only shown when [alwaysVisible] is false.
 * Defaults to 'search' icon.
 */
backIcon: string = 'search';
/**
 * showUnderline?: boolean
 * Sets if the input underline should be visible. Defaults to 'false'.
 */
showUnderline: boolean = false;
/**
 * debounce?: number
 * Debounce timeout between keypresses. Defaults to 400.
 */
debounce: number = 400;
/**
 * alwaysVisible?: boolean
 * Sets if the input should always be visible. Defaults to 'false'.
 */
alwaysVisible: boolean = false;
/**
 * placeholder?: string
 * Placeholder for the underlying input component.
 */
placeholder: string;
/**
 * searchDebounce: function($event)
 * Event emitted after the [debounce] timeout.
 */
onSearchDebounce: EventEmitter<string> = new EventEmitter<string>();
/**
 * search: function($event)
 * Event emitted after the key enter has been pressed.
 */
onSearch: EventEmitter<string> = new EventEmitter<string>();
/**
 * clear: function()
 * Event emitted after the clear icon has been clicked.
 */
onClear: EventEmitter<void> = new EventEmitter<void>();
/**
 * Method executed when the search icon is clicked.
 * @return {?}
 */
searchClicked(): void {
    if (this.alwaysVisible || !this._searchVisible) {
      this._searchInput.focus();
    }
    this.toggleVisibility();
  }
/**
 * @return {?}
 */
toggleVisibility(): void {
    this._searchVisible = !this._searchVisible;
  }
/**
 * @param {?} value
 * @return {?}
 */
handleSearchDebounce(value: string): void {
    this.onSearchDebounce.emit(value);
  }
/**
 * @param {?} value
 * @return {?}
 */
handleSearch(value: string): void {
    this.onSearch.emit(value);
  }
/**
 * @return {?}
 */
handleClear(): void {
    this.onClear.emit(undefined);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css' ],
  animations: [
    trigger('inputState', [
      state('0', style({
        width: '0%',
        'margin-left': '0px',
        'margin-right': '0px',
      })),
      state('1',  style({
        width: '100%',
        'margin-left': '*',
        'margin-right': '*',
      })),
      transition('0 => 1', animate('200ms ease-in')),
      transition('1 => 0', animate('200ms ease-out')),
    ]),
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_searchInput': [{ type: ViewChild, args: [TdSearchInputComponent, ] },],
'backIcon': [{ type: Input, args: ['backIcon', ] },],
'showUnderline': [{ type: Input, args: ['showUnderline', ] },],
'debounce': [{ type: Input, args: ['debounce', ] },],
'alwaysVisible': [{ type: Input, args: ['alwaysVisible', ] },],
'placeholder': [{ type: Input, args: ['placeholder', ] },],
'onSearchDebounce': [{ type: Output, args: ['searchDebounce', ] },],
'onSearch': [{ type: Output, args: ['search', ] },],
'onClear': [{ type: Output, args: ['clear', ] },],
};
}

function TdSearchBoxComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdSearchBoxComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdSearchBoxComponent.ctorParameters;
/** @type {?} */
TdSearchBoxComponent.propDecorators;
/** @type {?} */
TdSearchBoxComponent.prototype._searchVisible;
/** @type {?} */
TdSearchBoxComponent.prototype._searchInput;
/**
 * backIcon?: string
 * The icon used to close the search toggle, only shown when [alwaysVisible] is false.
 * Defaults to 'search' icon.
 * @type {?}
 */
TdSearchBoxComponent.prototype.backIcon;
/**
 * showUnderline?: boolean
 * Sets if the input underline should be visible. Defaults to 'false'.
 * @type {?}
 */
TdSearchBoxComponent.prototype.showUnderline;
/**
 * debounce?: number
 * Debounce timeout between keypresses. Defaults to 400.
 * @type {?}
 */
TdSearchBoxComponent.prototype.debounce;
/**
 * alwaysVisible?: boolean
 * Sets if the input should always be visible. Defaults to 'false'.
 * @type {?}
 */
TdSearchBoxComponent.prototype.alwaysVisible;
/**
 * placeholder?: string
 * Placeholder for the underlying input component.
 * @type {?}
 */
TdSearchBoxComponent.prototype.placeholder;
/**
 * searchDebounce: function($event)
 * Event emitted after the [debounce] timeout.
 * @type {?}
 */
TdSearchBoxComponent.prototype.onSearchDebounce;
/**
 * search: function($event)
 * Event emitted after the key enter has been pressed.
 * @type {?}
 */
TdSearchBoxComponent.prototype.onSearch;
/**
 * clear: function()
 * Event emitted after the clear icon has been clicked.
 * @type {?}
 */
TdSearchBoxComponent.prototype.onClear;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
